var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeverBefore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "never-before_svg__a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#never-before_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.137 27.048l-9.01-6.132c-2.061 1.15-4.156.92-5.584.506-1.159-.333-1.971-1.426-1.971-2.657 0-.23.14-.443.347-.53.247-.11 6.115-2.634 9.475-2.634.19 0 .381.017.577.023-.773-.351-1.999-.547-3.561-.547-1.395 0-3.237.782-4.861 1.473-1.126.477-2.128.897-2.923 1.047v9.158c0 .04-.006.08-.012.12l2.296 2.503a10.228 10.228 0 002.823 2.163l2.873 1.485a.44.44 0 00.504-.064.477.477 0 00.145-.397.446.446 0 00-.224-.356l-1.377-.806a.576.576 0 01-.208-.782.553.553 0 01.762-.219l.94.553 3.036 1.507a.532.532 0 00.633-.138.551.551 0 00-.129-.823l-3.338-2.042a.58.58 0 01-.19-.788.554.554 0 01.767-.202l2.016 1.237 2.111.926a.935.935 0 001.193-.385c.135-.224.174-.489.118-.748a.982.982 0 00-.437-.61l-1.103-.69-.51-.316-1.988-1.243a.58.58 0 01-.19-.788.556.556 0 01.773-.196l5.112 3.193a1.019 1.019 0 001.339-.23 1.084 1.084 0 00-.224-1.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.394 16.751c-2.665 0-7.296 1.824-8.657 2.382a1.608 1.608 0 001.109 1.185c1.282.374 3.197.575 5.006-.57a.56.56 0 01.605.012l9.296 6.328c.252.172.459.39.616.644v-8.145c-.571-.103-1.3-.333-2.167-.604-1.736-.546-3.892-1.23-5.808-1.23zm-12.454.282H8.566a.572.572 0 00-.566.581v8.347c0 .322.252.581.566.581h2.374a.572.572 0 00.566-.58v-8.349a.572.572 0 00-.566-.581zm24.494.92h-2.38a.572.572 0 00-.565.581v8.353c0 .323.252.581.565.581h2.38a.571.571 0 00.566-.58v-8.355a.571.571 0 00-.566-.58z"
  }))))));
}
export default SvgNeverBefore;